export enum ButtonText {
  Next = 'Next',
  RequestLoginCode = 'Request Login Code',
  Confirm = 'Confirm',
  SignIn = 'Sign In',
}

export enum InputLabelText {
  EmailAddress = 'Email Address',
  Password = 'Password',
  PassCode = 'PassCode',
}

export enum Align {
  Center = 'center',
  Inherit = 'inherit',
  Left = 'left',
  Right = 'right',
  Justify = 'justify',
}

export enum Variant {
  Caption = 'caption',
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
  H4 = 'h4',
  H5 = 'h5',
  H6 = 'h6',
  Inherit = 'inherit',
  Tooltip = 'tooltip',
  HelperText = 'helperText',
  Body2 = 'body2',
  Subtitle1 = 'subtitle1',
  Subtitle2 = 'subtitle2',
  Body1 = 'body1',
  Overline = 'overline',
  Body3 = 'body3',
  ButtonLarge = 'buttonLarge',
  ButtonMedium = 'buttonMedium',
  ButtonSmall = 'buttonSmall',
  AvatarLetter = 'avatarLetter',
  InputText1 = 'inputText1',
  InputText2 = 'inputText2',
  AlertTitle = 'alertTitle',
  TableHeader1 = 'tableHeader1',
  TableHeader2 = 'tableHeader2',
  InputLabel = 'inputLabel',
  Chip = 'chip',
  Badge = 'badge',
  Body1Semibold = 'body1Semibold',
  Body1Bold = 'body1Bold',
  Body2Semibold = 'body2Semibold',
  Body2Bold = 'body2Bold',
  Body3Semibold = 'body3Semibold',
  Body3Bold = 'body3Bold',
  Caps1 = 'caps1',
  Caps1Bold = 'caps1Bold',
  Caps2 = 'caps2',
  Caps2Bold = 'caps2Bold',
  Caps3 = 'caps3',
  Caps3Bold = 'caps3Bold',
  Caps4 = 'caps4',
  Caps4Bold = 'caps4Bold',
  Body4Semibold = 'body4Semibold',
}

enum TypographyColorVariant {
  Main = 'main',
  Dark = 'dark',
  Light = 'light',
  Contrast = 'contrast',
}

type TypographyColors = {
  Primary: Record<keyof typeof TypographyColorVariant, string>;
  Secondary: Record<keyof typeof TypographyColorVariant, string>;
  Error: Record<keyof typeof TypographyColorVariant, string>;
  Info: Record<keyof typeof TypographyColorVariant, string>;
  Warning: Record<keyof typeof TypographyColorVariant, string>;
  Success: Record<keyof typeof TypographyColorVariant, string>;
  Text: Record<'Primary' | 'Secondary' | 'Disabled', string>;
  Action: Record<'Active' | 'Hover' | 'Selected' | 'Disabled' | 'Focus', string>;
  Common: Record<'White' | 'Black', string>;
  Background: Record<'Default' | 'Paper', string>;
};

export const TypographyColor: TypographyColors = {
  Primary: {
    Main: 'primary.main',
    Dark: 'primary.dark',
    Light: 'primary.light',
    Contrast: 'primary.contrast',
  },
  Secondary: {
    Main: 'secondary.main',
    Dark: 'secondary.dark',
    Light: 'secondary.light',
    Contrast: 'secondary.contrast',
  },
  Error: {
    Main: 'error.main',
    Dark: 'error.dark',
    Light: 'error.light',
    Contrast: 'error.contrast',
  },
  Info: {
    Main: 'info.main',
    Dark: 'info.dark',
    Light: 'info.light',
    Contrast: 'info.contrast',
  },
  Warning: {
    Main: 'warning.main',
    Dark: 'warning.dark',
    Light: 'warning.light',
    Contrast: 'warning.contrast',
  },
  Success: {
    Main: 'success.main',
    Dark: 'success.dark',
    Light: 'success.light',
    Contrast: 'success.contrast',
  },
  Text: {
    Primary: 'text.primary',
    Secondary: 'text.secondary',
    Disabled: 'text.disabled',
  },
  Action: {
    Active: 'action.active',
    Hover: 'action.hover',
    Selected: 'action.selected',
    Disabled: 'action.disabled',
    Focus: 'action.focus',
  },
  Common: {
    White: 'common.white',
    Black: 'common.black',
  },
  Background: {
    Default: 'background.default',
    Paper: 'background.paper',
  },
};

export enum TextFieldColor {
  Success = 'success',
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
  Primary = 'primary',
  Secondary = 'secondary',
}
